import { render } from "./notesDialog.vue?vue&type=template&id=66c7ef45"
import script from "./notesDialog.vue?vue&type=script&lang=js"
export * from "./notesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__